export default __webpack_public_path__ + "static/media/004-medal-1.86be04cf.png";